import React from "react";

const ReportLayout: React.FC<{ reportData: any; setReportData: any; onNext: () => void }> = ({ reportData, setReportData, onNext }) => {
    const handleStyleChange = (e: any) => {
        setReportData({
            ...reportData,
            styles: { ...reportData.styles, [e.target.name]: e.target.value }
        });
    };

    return (
        <div>
            <h3>Step 3: Customize Report Layout</h3>

            <label>Header Text:</label>
            <textarea name="headerText" value={reportData.styles?.headerText || ""} onChange={handleStyleChange} />

            <label>Header Color:</label>
            <input type="color" name="headerColor" value={reportData.styles?.headerColor || "#000000"} onChange={handleStyleChange} />

            <label>Row Color (Odd):</label>
            <input type="color" name="rowColorOdd" value={reportData.styles?.rowColorOdd || "#ffffff"} onChange={handleStyleChange} />

            <label>Row Color (Even):</label>
            <input type="color" name="rowColorEven" value={reportData.styles?.rowColorEven || "#f2f2f2"} onChange={handleStyleChange} />

            <label>Grouping Level:</label>
            <select name="groupingLevel" value={reportData.styles?.groupingLevel || "None"} onChange={handleStyleChange}>
                <option value="None">None</option>
                <option value="Level1">Level 1</option>
                <option value="Level2">Level 2</option>
            </select>

            <button onClick={onNext}>Next</button>
        </div>
    );
};

export default ReportLayout;
